import { gql, useMutation } from '@apollo/client'
import { useEffect } from 'react'
import { ViewBrandMutation, ViewBrandMutationVariables, Scalars } from 'types/graphql'
import { useCurrentUser } from 'modules/auth/useCurrentUser'
import { viewedBrandFragment } from '../queries/useViewedBrands'

const viewBrandMutation = gql`
  mutation ViewBrand($brandId: ID!) {
    createBrandView(brandId: $brandId) {
      list {
        id
      }
      brand {
        ...ViewedBrandFragment
      }
    }
  }
  ${viewedBrandFragment}
`

export const useCreateBrandView = (brandId?: Scalars['ID']) => {
  const [createView] = useMutation<ViewBrandMutation, ViewBrandMutationVariables>(viewBrandMutation)
  const { isLoggedIn } = useCurrentUser()

  useEffect(() => {
    if (isLoggedIn && brandId) {
      createView({
        variables: {
          brandId
        }
      })
    }
  }, [createView, brandId, isLoggedIn])

  return null
}
